export const TEXTS = {
  TITLE: 'Bag',
  ITEMS: 'Items',
};

const CLOSE_IN_DURATION = 3000;

export const COUPON_SUCCESS_NUDGE_PROPS = {
  actionName: 'Ok, Thanks',
  title: 'You Saved ',
  subtitle: 'Congratulations on more savings!!',
  closeIn: CLOSE_IN_DURATION,
  showHeader: false,
};

export const BEST_COUPON_STATUS = {
  APPLIED: 'applied',
  EXPIRED: 'expired',
  EXPIRING: 'expiring',
  APPLICABLE: 'applicable',
  NOT_APPLICABLE: 'not_applicable',
} as const;

export const CART_REWARDS_MULTIPLIER = 1;

export const FREE_SAMPLE_FLAG = 'isFreeSampleEnabled';
export const FREE_GIFTS_BANNER_CLICK = 'pick_free_gift_nudge_click';

export const OFFER_GRATIFICATION_EXP = 'offer-gratification-ab';
export const OFFER_GRATIFICATION_VAR = 'offer-gratification-a';